<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.partner.editPrice.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <input
          type="number"
          class="form-control"
          [placeholder]="
            'pricing.partner.details.placeholders.price' | translate
          "
          [formControl]="priceFormControl"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!priceFormControl.value"
      (click)="updatePrice()"
    >
      {{ 'common.buttons.btnUpdate' | translate }}
    </button>
  </div>
</div>
